module.exports = __webpack_public_path__ + "static/media/npb-back.913934ae.png";